<template>
  <div style="display: inline-block; min-height: 60px">

    <span style="display: block; font-size: 16px; line-height: 18px;" v-if="coverageOption || policyNumber">
      <span v-if="coverageOption">{{coverageOption}}</span>
      <span v-if="coverageOption && policyNumber">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
      <span v-if="policyNumber">{{policyNumber}}</span>
    </span>

    <span style="display: block; font-size: 12px; line-height: 14px;" v-if="agency">
      <span v-if="agency">{{agency}}</span>
    </span>

    <span style="display: block; font-size: 12px; line-height: 14px;" v-if="insuredName">
      <span>{{insuredName}}</span>
    </span>

    <span style="display: block; font-size: 12px; line-height: 14px;" v-if="riskAddress">
      <span v-if="riskAddress">{{riskAddress}}</span> <span v-if="riskCounty">({{riskCounty}}&nbsp;County)</span>
    </span>

    <span style="display: block; font-size: 12px; line-height: 14px;" v-if="effectiveDate || expirationDate">
      <span v-if="effectiveDate">{{effectiveDate}}</span>
      <span v-if="effectiveDate && expirationDate">&nbsp;-&nbsp;</span>
      <span v-if="expirationDate">{{expirationDate}}</span>
    </span>

  </div>
</template>

<script>
  import { formatDateForDisplay } from '@/scripts/helper';
  import { PolicyService } from '@/api/PolicyService';

  export default {
    name: 'PolicyServicingHeader',
    data () {
      return {
        policy: null
      };
    },
    props: {
      account: {
        type: Object,
        default: null
      },
      initalPolicy: {
        type: Object,
        default: null
      }
    },
    computed: {
      coverageOption () {
        if (!this.policy) return '';

        // Excess flood accounts have Product 'FloodExcess' (so the V2 policy is loaded, with FormType directly
        // under Policy); the V1 flood policy carries FormType under Header ('Primary Flood' / 'Excess Flood')
        const formType = this.policy.Policy.Header?.FormType?.Value || this.policy.Policy.FormType?.Value || '';
        if (this.account?.Product?.toLowerCase() === 'floodexcess' || formType.toLowerCase().includes('excess')) {
          return 'FLOODEXCESS';
        }

        if (this.policy.Policy.Header?.ProductType?.Value) {
          return this.policy.Policy.Header.ProductType.Value.toUpperCase();
        } else if (this.policy.Policy?.ProductType?.Value) {
          return this.policy.Policy.ProductType.Value.toUpperCase();
        }

        return '';
      },
      policyNumber () {
        if (!this.policy) return '';

        if (this.policy.Policy.Header?.SubmissionNumber) {
          return this.policy.Policy.Header.SubmissionNumber.toUpperCase();
        } else if (this.policy.Policy?.PolicyNumber) {
          return this.policy.Policy.PolicyNumber;
        }

        return '';
      },
      insuredName () {
        let primaryInsured = this.policy?.Policy?.Insured?.PrimaryInsured;
        if (primaryInsured) {
          if (!primaryInsured.EntityName) {
            return `${primaryInsured.FirstName} ${primaryInsured.LastName}`;
          }
          return primaryInsured.EntityName;
        }

        return '';
      },
      effectiveDate () {
        if (!this.policy) return '';

        if (this.policy.Policy.Header?.EffectiveDate) {
          return formatDateForDisplay(this.policy.Policy.Header.EffectiveDate, true);
        } else if (this.policy.Policy?.TermBegin) {
          return formatDateForDisplay(this.policy.Policy.TermBegin, true);
        }

        return '';
      },
      expirationDate () {
        if (!this.policy) return '';

        if (this.policy.Policy.Header?.ExpirationDate) {
          return formatDateForDisplay(this.policy.Policy.Header.ExpirationDate, true);
        } else if (this.policy.Policy?.TermEnd) {
          return formatDateForDisplay(this.policy.Policy.TermEnd, true);
        }

        return '';
      },
      agency () {
        if (!this.account) return '';
        return this.agencyDisplay(this.account.Agency, this.account.Agent);
      },
      riskAddress () {
        if (!this.account) return '';
        return this.addressDisplay(this.account.Risk);
      },
      riskCounty () {
        if (!this.account) return '';
        return this.account.Risk.County;
      },
      policyId () {
        return this.$route.query.policyId;
      },
      accountId () {
        return this.$route.query.accountId;
      }
    },
    methods: {
      agencyDisplay (agency, agent) {
        return agency?.OrgName + ' (' + agency?.City + ', ' + agency?.State + ') - ' + agent?.Name;
      },
      addressDisplay (risk) {
        if (!risk) return '';

        return `${risk.Street1}, ${risk.City}, ${risk.State} ${risk.Postal}, ${risk.Country}`;
      },
      returnToAccount () {
        this.$router.push({ path: '/account', query: { id: this.accountId } });
      },
      returnToDashboard () {
        this.$router.push({ path: '/dashboard' });
      }
    },
    mounted () {
      if (this.policyId === null || this.policyId === undefined && this.accountId !== null && this.accountId !== undefined) {
        this.returnToAccount();
      } else if (this.accountId === null || this.accountId === undefined) {
        this.returnToDashboard();
      }
    },
    watch: {
      account: {
        immediate: true,
        deep: true,
        handler () {
          if (!this.account || this.policyId === null || this.policyId === undefined) {
            return;
          }
          if (this.account.Product.toLowerCase() === "flood") {
            PolicyService.get({ submissionId: this.account.id, policyId: this.policyId })
            .then((response) => {
              if (response) {
                this.policy = response;
              }
            })
            .catch(() => {
              this.$store.dispatch('toastError', { Message: 'Failed to retrieve policy data' });
              this.returnToAccount();
            });
          } else if (!this.initalPolicy) {
            PolicyService.getV2({ submissionId: this.account.id, policyId: this.policyId })
            .then((response) => {
              if (response) {
                this.policy = response;
              }
            })
            .catch(() => {
              this.$store.dispatch('toastError', { Message: 'Failed to retrieve policy data' });
              this.returnToAccount();
            });
          } else {
            this.policy = this.initalPolicy;
          }
        }
      }
    }
  };
</script>
